export function assetUrl(path: string): string {
  return `${__BASE_PATH__}${path.replace(/^\//, '')}`.replace(/([^:]\/)\/+/g, '$1');
}
